import type { LucideIcon } from 'lucide-react'
import {
  Banknote,
  BarChart3,
  Bell,
  BookOpen,
  BookUser,
  Bookmark,
  Building2,
  CalendarDays,
  CheckCircle2,
  ClipboardList,
  Clock3,
  Database,
  FileImage,
  FileText,
  FolderOpen,
  House,
  ImageIcon,
  Info,
  LayoutDashboard,
  LayoutGrid,
  List,
  ListChecks,
  Lock,
  Mail,
  MapPin,
  MessageSquareText,
  Package,
  Paperclip,
  Phone,
  Printer,
  Search,
  Settings2,
  ShoppingCart,
  Star,
  User,
  Users,
  Wrench,
} from 'lucide-react'

export const navIcons = {
  admin: Settings2,
  catalog: Package,
  currentSquares: CalendarDays,
  dashboard: LayoutDashboard,
  directories: Database,
  profile: User,
  reports: BarChart3,
  schemas: ClipboardList,
  squareGroups: LayoutGrid,
  training: BookOpen,
}

export function resolveBackendIcon(iconName: string | null | undefined, fallback: LucideIcon = FolderOpen) {
  const value = (iconName ?? '').toLowerCase()

  if (!value) {
    return fallback
  }

  if (value.includes('address-book')) {
    return BookUser
  }
  if (value.includes('bell')) {
    return Bell
  }
  if (value.includes('bookmark')) {
    return Bookmark
  }
  if (value.includes('building')) {
    return Building2
  }
  if (value.includes('phone')) {
    return Phone
  }
  if (value.includes('users')) {
    return Users
  }
  if (value.includes('user')) {
    return User
  }
  if (value.includes('calendar') || value.includes('clock')) {
    return value.includes('clock') ? Clock3 : CalendarDays
  }
  if (value.includes('check')) {
    return CheckCircle2
  }
  if (value.includes('clipboard')) {
    return ClipboardList
  }
  if (value.includes('shopping') || value.includes('cart') || value.includes('basket')) {
    return ShoppingCart
  }
  if (value.includes('comment')) {
    return MessageSquareText
  }
  if (value.includes('file') || value.includes('doc')) {
    return FileText
  }
  if (value.includes('folder')) {
    return FolderOpen
  }
  if (value.includes('envelope') || value.includes('mail')) {
    return Mail
  }
  if (value.includes('home')) {
    return House
  }
  if (value.includes('image')) {
    return value.includes('file') ? FileImage : ImageIcon
  }
  if (value.includes('info')) {
    return Info
  }
  if (value.includes('list')) {
    return List
  }
  if (value.includes('lock')) {
    return Lock
  }
  if (value.includes('map')) {
    return MapPin
  }
  if (value.includes('money') || value.includes('bill')) {
    return Banknote
  }
  if (value.includes('paperclip')) {
    return Paperclip
  }
  if (value.includes('print')) {
    return Printer
  }
  if (value.includes('database')) {
    return Database
  }
  if (value.includes('chart')) {
    return BarChart3
  }
  if (value.includes('book')) {
    return BookOpen
  }
  if (value.includes('package') || value.includes('box')) {
    return Package
  }
  if (value.includes('search')) {
    return Search
  }
  if (value.includes('setting') || value.includes('cog')) {
    return Settings2
  }
  if (value.includes('star')) {
    return Star
  }
  if (value.includes('task')) {
    return ListChecks
  }
  if (value.includes('wrench') || value.includes('tool')) {
    return Wrench
  }

  return fallback
}
